// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__7iWUT","submitButton":"styles_submitButton__EAZhF"};